import React from 'react';
import { Link } from 'react-router-dom';
import SearchForm from '../components/SearchForm';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * /book entry — same app-style search form as the homepage.
 */
const Book = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-[#FFF5F8] px-4 py-8 sm:py-12">
      <div className="mx-auto w-full max-w-xl sm:max-w-2xl">
        <div className="mb-5 text-center">
          <h1 className="font-heading text-2xl font-extrabold tracking-wide text-[#E91E63] sm:text-3xl">
            {t('bookYourJourney') || 'Book your journey'}
          </h1>
          <p className="mt-2 font-body text-sm text-[#6B7280]">
            {t('searchBookPremium')}
          </p>
        </div>
        <SearchForm />
        <p className="mt-8 text-center">
          <Link
            to="/"
            className="text-sm font-semibold text-[#E91E63] underline hover:text-[#C2185B]"
          >
            ← Back to home
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Book;
